// 通用文字格式化小工具，原本定義在 EventFunnelPage.js 內部。

/** 秒數 -> "m:ss"。 */
export function formatMmSs(sec) {
  if (sec == null) return "?";
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${String(s).padStart(2, "0")}`;
}

// 休息秒數精確顯示到秒，不要只捨入到分鐘——測試/正式使用時很多暫停只有幾十秒，
// 捨入成分鐘會直接變成「休息 0 分」，等於沒顯示到。
export function formatRestDuration(sec) {
  if (sec == null) return "尚未恢復播放";
  const m = Math.floor(sec / 60);
  const s = Math.round(sec % 60);
  if (m === 0) return `休息 ${s} 秒`;
  if (s === 0) return `休息 ${m} 分`;
  return `休息 ${m} 分 ${s} 秒`;
}
